import React from "react";
import { Table, Tag, Button, Tooltip, Typography, Space } from "antd";
import { EyeOutlined, CopyOutlined } from "@ant-design/icons";
import { message } from "antd";

const { Text } = Typography;

const AssignmentsTable = ({ assignments, loading, onViewDetails }) => {
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    message.success("BOTPC copied to clipboard");
  };

  const getStatusColor = (status) => {
    const statusColors = {
      "Pending Selection": "default",
      "Items Selected": "processing",
      "Pending Payment": "warning",
      "Partially Paid": "orange",
      Paid: "success",
      "Ready for Pickup": "purple",
      "Partially Collected": "cyan",
      "Fully Collected": "blue",
      Cleared: "green",
      Cancelled: "error",
    };
    return statusColors[status] || "default";
  };

  const columns = [
    {
      title: "BOTPC",
      dataIndex: "botpc",
      key: "botpc",
      render: (botpc) => (
        <Space>
          <Text code>{botpc}</Text>
          <Tooltip title="Copy BOTPC">
            <Button
              type="text"
              size="small"
              icon={<CopyOutlined />}
              onClick={() => copyToClipboard(botpc)}
            />
          </Tooltip>
        </Space>
      ),
    },
    {
      title: "Student",
      key: "student",
      render: (_, record) => (
        <div>
          <div>{record.student_name || "N/A"}</div>
          <Text type="secondary" style={{ fontSize: "12px" }}>
            {record.student_spc}
          </Text>
        </div>
      ),
    },
    {
      title: "Template",
      dataIndex: "template_name",
      key: "template_name",
      render: (text) => text || "N/A",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <Tag color={getStatusColor(status)}>{status}</Tag>,
    },
    {
      title: "Total Amount",
      dataIndex: "total_amount",
      key: "total_amount",
      render: (amount) => `UGX ${parseFloat(amount || 0).toFixed(2)}`,
    },
    {
      title: "Balance",
      dataIndex: "balance",
      key: "balance",
      render: (balance) => (
        <Text strong type={parseFloat(balance) > 0 ? "danger" : "success"}>
          UGX {parseFloat(balance || 0).toFixed(2)}
        </Text>
      ),
    },
    {
      title: "Payment Deadline",
      dataIndex: "payment_deadline",
      key: "payment_deadline",
      render: (date) => date || "N/A",
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Tooltip title="View Details">
          <Button
            type="link"
            icon={<EyeOutlined />}
            onClick={() => onViewDetails(record)}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={assignments}
      rowKey="id"
      loading={loading}
      pagination={{
        pageSize: 10,
        showSizeChanger: true,
        showTotal: (total) => `Total ${total} assignments`,
      }}
      scroll={{ x: 900 }}
    />
  );
};

export default AssignmentsTable;
